import React, {useEffect, useState} from 'react';
import dxDataGrid from 'devextreme/ui/data_grid';
import styles from './index.module.scss';
import { Utilities, Dictionary } from '@utils';

interface ITableErrorsProps{
    calculatedSumPl?(item: any): boolean;
    calculatedReqFields?(item: any): boolean;
    calculatedGoal?(item: any): boolean;
    calculatedCriteria?(item: any): boolean;
    changeStyles?(parentGrid: dxDataGrid): boolean;
    checkEmptyValues?(item: any): boolean;
    checkEmptyPlan?(item: any): boolean;
    gridId: string;
    tableAlerts: string;
    initialValidate: boolean;
    followupLabels: Dictionary<string, string>;
    msgInitialError: string;
    tourActive?: boolean;
    initialValidateActPlan?: boolean;
    initialValidateEmptyValues?: boolean;
}

const TableErrors: React.FC<ITableErrorsProps> = ({calculatedSumPl, calculatedReqFields, calculatedGoal, changeStyles, calculatedCriteria, checkEmptyValues,
    checkEmptyPlan, gridId, tableAlerts, initialValidate, followupLabels, msgInitialError, tourActive, initialValidateActPlan, initialValidateEmptyValues = true}: ITableErrorsProps) => {
    const [parentGrid, setParentGrid] = useState<dxDataGrid>();    
    const [error, setError] = useState(null);

    const validateGridDataErrors = (data:any) => {
        let isError = false;
        let firstError: string = null;
        if(data[0] !== undefined){
            if((tableAlerts === gridId || tableAlerts === 'All') || (error && !Utilities.isNullEmptyObject(tableAlerts))){
                data.forEach((item:any, index: number) => {  
                    if(parentGrid !== undefined){  
                        const rowElements = parentGrid.getRowElement(index);
                        if(rowElements !== undefined){
                            let sumPl = false, reqFields = !!tourActive, goal = false, criteria = false, emptyPlan = false, emptyValues = false, errorName: string = 'noError'

                            emptyValues = checkEmptyValues ? checkEmptyValues?.(item) : false
                            sumPl = calculatedSumPl ? !calculatedSumPl(item) : false
                            reqFields = calculatedReqFields ? !calculatedReqFields(item) : false
                            goal = calculatedGoal ? !calculatedGoal(item) : false
                            criteria = calculatedCriteria ? !calculatedCriteria(item) : false
                            emptyPlan = checkEmptyPlan? checkEmptyPlan(item) : false


                            if(tourActive && !isError) setError(followupLabels?.get("alertRequiredFields"));
                            if(emptyPlan && !isError) setError(followupLabels?.get("activityPlanError"));
                            else if(sumPl && !isError) setError(followupLabels?.get("alertMonthsPlan"));
                            else if((reqFields || emptyValues) && !isError) setError(followupLabels?.get("alertRequiredFields"));
                            else if(goal && !isError) setError(followupLabels?.get("alertReachedGoal"));
                            else if(criteria && !isError) setError(followupLabels?.get("alertIndicatorCriteria"));
                            //else if(emptyPlan && !isError) setError(followupLabels?.get("activityPlanError"));

                            errorName = sumPl ? 'sumPl' : (reqFields || emptyValues) ? 'reqFields' : (goal) ? 'goal' : (criteria) ? 'criteria' : (emptyPlan) ? 'emptyPlan' : 'noError'

                            if(((sumPl || reqFields || goal || criteria || emptyPlan || emptyValues) && (errorName === firstError || !firstError)) || tourActive){                        
                                rowElements[0].childNodes.forEach((child:any) => {  
                                    child.classList.add(styles.tdError);
                                });
                                isError = true;
                                firstError = errorName;
                            }else{
                                rowElements[0].childNodes.forEach((child:any) => {  
                                    child.classList.remove(styles.tdError);
                                });
                            }
                        }
                    }    
                });
                if(!isError) setError(null)
            }
            changeStyles?.(parentGrid)        
        }  
    }

    const validateInitialValue = (data:any) => {
        let isError = false;
        if(data[0] !== undefined){
            //if(initialValidate || initialValidateActPlan){
            if(initialValidate){
                data.forEach((item:any, index: number) => {  
                    if(parentGrid !== undefined && initialValidateEmptyValues){  
                        const rowElements = parentGrid.getRowElement(index);
                        if(rowElements !== undefined){
                            let emptyValues = checkEmptyValues?.(item)
                            //let emptyPlan = checkEmptyPlan?.(item)
                            
                            if((emptyValues) && !isError) {
                                setError(msgInitialError);
                            }
                            /* if((emptyPlan) && !isError) {
                                setError(followupLabels?.get("activityPlanError"));
                            } */

                            if(emptyValues){       
                            //if(emptyValues || emptyPlan){                        
                                rowElements[0].childNodes.forEach((child:any) => {  
                                    child.classList.add(styles.tdError);
                                });
                                isError = true;
                            }else{
                                rowElements[0].childNodes.forEach((child:any) => {  
                                    child.classList.remove(styles.tdError);
                                });
                            }
                        }
                    }    
                          
                });
                if(!isError) setError(null)
            }
            changeStyles?.(parentGrid)  
        }  
    }

    useEffect(()=>{        
        if(parentGrid !== undefined){
            validateGridDataErrors(parentGrid?.getDataSource().items());
            parentGrid.option("onContentReady",(data:any) => {
                validateGridDataErrors(data.component.getDataSource().items())
            });
            parentGrid.option("onOptionChanged", (data: any ) => {
                if(data.name === "dataSource"){
                    validateGridDataErrors(data);
                }
            })
        }
        // eslint-disable-next-line
    },[parentGrid, tableAlerts]);

    useEffect(()=>{        
        if(parentGrid !== undefined){
            parentGrid.option("onContentReady",(data:any) => {
                validateInitialValue(data.component.getDataSource().items())
            });
        }
        // eslint-disable-next-line
    },[parentGrid, initialValidate]);
    //},[parentGrid, initialValidate, initialValidateActPlan]);

    useEffect(()=>{
        if(gridId  !== undefined){
            const container = document.getElementById(gridId) as HTMLElement;
            const instance = dxDataGrid.getInstance(container) as dxDataGrid;
            setParentGrid(instance)
        }
    },[gridId])

    useEffect(()=>{
        if(Utilities.isNullEmptyObject(tableAlerts)){
            setError(null)
        }
    },[tableAlerts])
    
    return (
        <>
            <div style={{width:"100%", textAlign:"center"}}>
                <h6 style={{color:"red", padding:"1rem 1rem 0", minHeight: "31px"}}>{error || ''}</h6>
            </div>
        </>
    )
}

export default TableErrors;